package com.exura.core.domain

import kotlinx.datetime.Clock

sealed interface SimpleEvent {

    data object Success : SimpleEvent

    data class Error(
        val message: String?,
        val timestampMillis: Long = Clock.System.now().toEpochMilliseconds(),
    ) : SimpleEvent
}
